/**
 * Stable CSS class names for E2E — Detailed stock search page & related UI.
 */
export const DSS = {
    page: 'detail-stock-search-page',
    searchFieldWrap: 'detail-stock-search-page__search-field-wrap',
    resultsSection: 'detail-stock-search-page__results-section',
    resultsToolbar: 'detail-stock-search-page__results-toolbar',
    resultsTitleCluster: 'detail-stock-search-page__results-title-cluster',
    resultsActions: 'detail-stock-search-page__results-actions',
    inputButtonGetStock: 'detail-stock-search-input--button-get-stock',
    inputButtonUpdateInventory: 'detail-stock-search-input--button-update-inventory',
    productSummaryWrap: 'detail-stock-search-page__product-summary-wrap',
    stockSectionHeader: 'detail-stock-search-page__stock-section-header',
    stockTableWrap: 'detail-stock-search-page__stock-table-wrap',
    emptyStateWrap: 'detail-stock-search-page__empty-state-wrap',
} as const;

export const DSP = {
    paper: 'detail-stock-search-product-summary',
    bodyRow: 'detail-stock-search-product-summary__body-row',
    thumbnailWrap: 'detail-stock-search-product-summary__thumbnail-wrap',
    fieldsGrid: 'detail-stock-search-product-summary__fields-grid',
} as const;

export const DST = {
    tableContainer: 'detail-stock-search-stock-table',
    inputIconExpandRow: 'detail-stock-search-stock-table-input--icon-button-expand-row',
    inputIconEntityDetail: 'detail-stock-search-stock-table-input--icon-button-entity-detail',
} as const;

export const DSD = {
    root: 'detail-stock-search-drawer',
    header: 'detail-stock-search-drawer__header',
    inputIconClose: 'detail-stock-search-drawer-input--icon-button-close',
    content: 'detail-stock-search-drawer__content',
    summaryPanel: 'detail-stock-search-drawer__summary-panel',
    jsonPre: 'detail-stock-search-drawer__json-pre',
} as const;

export const dssCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
export const dspCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
export const dstCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
export const dsdCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
